<div class="partner-accept-form">
  <form [formGroup]="acceptForm" (ngSubmit)="submit()">
    <div class="form-header">
      <h5 class="mb-0 font-size-14">{{ 'partner.accept.form.title' | translate }}</h5>
    </div>
    <div class="form-body">
      <p class="description">{{ 'partner.accept.form.description' | translate }}</p>
      <div class="form-group flex-lg-row flex-column">
        <div class="form-floating rounded">
          <input
            type="text"
            class="form-control border"
            id="username"
            formControlName="code"
            [placeholder]="'partner.accept.form.code.label' | translate"
          />
          <label for="username">{{ 'partner.accept.form.code.label' | translate }}</label>
        </div>
        <div class="form-floating rounded">
          <input
            type="text"
            class="form-control border"
            id="username"
            formControlName="secretCode"
            [placeholder]="'partner.accept.form.secret.code.label' | translate"
          />
          <label for="username">{{ 'partner.accept.form.secret.code.label' | translate }}</label>
        </div>
      </div>
      <div class="error-message">
        <fgbcl-errors></fgbcl-errors>
      </div>
    </div>
    <div class="form-footer">
      <button (click)="close(); $event.preventDefault()" class="btn btn-cancel text-danger fw-bold">
        {{ 'partner.add.form.cancel.button' | translate }}
      </button>
      <button type="submit" [disabled]="acceptForm.invalid" class="btn btn-success fw-bold">
        {{ 'partner.add.form.submit.button' | translate }}
      </button>
    </div>
  </form>
</div>
